import React from 'react'
import PropTypes from 'prop-types'
import FilterIconSVG from 'component/svgComponents/filter'
import Button from 'component/Button/index'

const OptionsView = ({
  setSideFilterVisible = () => {},
  translate = () => {},
}) => (
  <div className='float-right margin-top'>
    <Button
      className='btn btn-secondary'
      text={translate('mobile.filter')}
      onClick={setSideFilterVisible}
      svgComponent={<FilterIconSVG newDesign={false} className="margin-default-svg" />}
      svgIcon
    />
  </div>
)

OptionsView.propTypes = {
  setSideFilterVisible: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
}

export default OptionsView
